import styled from 'styled-components';
import { Layout } from 'antd';
const { Footer } = Layout;

export const StyledFooter = styled(Footer)`
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 1em 1em;
  }
`;

export type ImgIconsLegalProps = { src: string | undefined };

export const ImgIconsLegal =
    styled.img.attrs<ImgIconsLegalProps>((props: ImgIconsLegalProps) => ({
      src: props.src,
    }))`
  flex-grow: 0;
  object-fit: contain;
`;

export const ButtonsWrapper = styled.div`
  display: block;  
  text-align: center;
  margin: 3em auto 0 auto;
  max-width: 350px;
`;
